import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  translationBox: {
    display: 'flex',
    gap: '10px',
    '& .MuiSvgIcon-fontSizeSmall': {
      fontSize: '1.1em',
      position: 'relative',
      top: '2px',
    },
  },
  selected: {
    color: '#CF1F38',
    transition: 'color 0.3s ease-in-out',
    '&:hover': {
      color: '#CF1F38',
      cursor: 'pointer',
    },
  },
  notSelected: {
    color: '#959595',
    transition: 'color 0.3s ease-in-out',
    '&:hover': {
      color: '#CF1F38',
      cursor: 'pointer',
    },
  },
}));

export default useStyles;
